function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Cross Icon");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u2693\\uFE0F-The-Shipyard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\\u260DQronoport-/-Components-/-Notification",
  transform: "translate(-322.000000, -30.000000)",
  fill: "#06273A"
}, React.createElement("g", {
  id: "\\u260DQronoport-/-Foundation-/-icons-/-cross",
  transform: "translate(316.000000, 24.000000)"
}, React.createElement("path", {
  d: "M17.3033009,16.065864 C17.4491416,16.2117048 17.4491416,16.4503533 17.3033009,16.5961941 L16.5961941,17.3033009 C16.4503533,17.4491416 16.2117048,17.4491416 16.065864,17.3033009 L12,13.2374369 L7.93413601,17.3033009 C7.78829523,17.4491416 7.5496467,17.4491416 7.40380592,17.3033009 L6.69669914,16.5961941 C6.55085837,16.4503533 6.55085837,16.2117048 6.69669914,16.065864 L10.7625631,12 L6.69669914,7.93413601 C6.55085837,7.78829523 6.55085837,7.5496467 6.69669914,7.40380592 L7.40380592,6.69669914 C7.5496467,6.55085837 7.78829523,6.55085837 7.93413601,6.69669914 L12,10.7625631 L16.065864,6.69669914 C16.2117048,6.55085837 16.4503533,6.55085837 16.5961941,6.69669914 L17.3033009,7.40380592 C17.4491416,7.5496467 17.4491416,7.78829523 17.3033009,7.93413601 L13.2374369,12 L17.3033009,16.065864 Z",
  id: "cross"
}))));

var SvgCross = function SvgCross(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCross, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cross.87075fb9.svg";
export { ForwardRef as ReactComponent };